import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import AsyncTableComponent from '../Table/AsyncTableContainer';

import { getFullName } from '../Person/utils';
import { getExportTitle } from '../ViewExport/utils';

import { TABLE_CONSTANTS, TABLE_ID } from '../Table/constants';

import { TABLE_DATA_TYPES } from '../../staticData';
import { CopyToClipBoardButton, SwitchAgentButton } from '../Button';
import CellPersonWithImage from '../Table/CellPersonWithImage';
import { limitFilter } from '../Table/filters';
import RemoteDoormanAgentsListExport from './RemoteDoormanAgentsListExport';

const RemoteDoormanAgentsListComponent = (props) => {
  const {
    onLoad,
    items,
    getItems,
    listParams,
    listKey,
    onExport,
    onOpenAssignAgentModal,
  } = props;

  const columns = [
    {
      Header: 'Twilio Worker SID',
      id: 'worker_sid',
      headerClassName: 'sort',
      width: 370,
      accessor: ({ workerSid }, isExport) => {
        if (!workerSid) return 'N/A';
        if (isExport) return workerSid;
        return (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>{workerSid}</Box>
            <Box mr="1rem" />
            <CopyToClipBoardButton text={workerSid} />
          </Box>
        );
      },
    },
    {
      Header: 'Name',
      id: 'name',
      headerClassName: 'sort',
      accessor: ({ name }) => name,
    },
    {
      Header: 'Status',
      id: 'status',
      sortable: false,
      accessor: ({ status }) => status || 'N/A',
    },
    {
      Header: 'Person',
      id: 'person',
      headerClassName: 'sort',
      accessor: (entry, isExport) => {
        const { person } = entry;
        if (!person?.id) return 'N/A';
        if (isExport) return getFullName(person);
        const linkUrl = `/global-person-search/${person?.id}`;
        return (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>
              <CellPersonWithImage person={person} linkUrl={linkUrl} />
            </Box>
            <Box mr="1rem" />
            <SwitchAgentButton onClick={() => onOpenAssignAgentModal(entry)} />
          </Box>
        );
      },
    },
  ];

  const filters = [limitFilter(listParams)];

  const defaultParams = {
    offset: '0',
  };

  const action = null;
  const fieldsForBackendSort = [TABLE_CONSTANTS.created_at];
  const tableDataType = TABLE_DATA_TYPES.items;

  const title = 'Remote Doorman Agents List';
  const exportTitle = getExportTitle(title);
  const exportActions = (
    <RemoteDoormanAgentsListExport
      title={exportTitle}
      getDataForExport={onExport}
      columns={columns}
    />
  );

  return (
    <AsyncTableComponent
      tableId={TABLE_ID.remoteDoormanAgentsList}
      title={title}
      columns={columns}
      defaultSort={TABLE_CONSTANTS.created_at}
      fieldsForBackendSort={fieldsForBackendSort}
      filters={filters}
      showFiltersAreApplied={false}
      onLoad={onLoad}
      items={items}
      getItems={getItems}
      listParams={listParams}
      defaultParams={defaultParams}
      tableDataType={tableDataType}
      listKey={listKey}
      action={action}
      manual
      defaultSortDesc
      exportActions={exportActions}
      isHideSearch
    />
  );
};

RemoteDoormanAgentsListComponent.propTypes = {
  onLoad: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
  items: PropTypes.instanceOf(Object).isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  listKey: PropTypes.string.isRequired,
  onExport: PropTypes.func.isRequired,
  onOpenAssignAgentModal: PropTypes.func.isRequired,
};

export default RemoteDoormanAgentsListComponent;
